// import data from "../data/data.json";

import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Outlet, useNavigate, Link } from 'react-router-dom'

import '../css/first.css';

// const data = require('../data/data.json');




function First() {
    const [showDownLoad, setShowDownLoad] = useState(false);
    const navigate = useNavigate()
    const [data, setData] = useState(null);
    useEffect(() => {
        // 在这里加载JSON文件
        fetch('/data/data.1.json')
            .then(response => response.json())
            .then(data => {
                setData(data)
                setShowDownLoad(data.showDownLoad)
            }
            )
            .catch(error => console.error('Error loading JSON:', error));
    }, []);
    // 下载点击事件
    function downLoadHandle() {
        window.location.href = data.downLoadLink
    }
    // 点击立即游戏事件
    function playGameHandle(event) {

        let number = 0
        data.icon.forEach(element => {
            if (element.enable) {
                if (data.playGameLink != "") {
                    window.location.href = data.playGameLink + Date.now()
                } else {
                    toast.error('链接未配置!');
                }
            }
            if (!element.enable) {
                number++
            }
        });
        if (number == data.icon.length) {
            toast.error('暂未开启!');
        }

        // toast.success('操作成功!');
        // toast.error('发生错误!');
        // toast.warn('警告!');
        // toast.info('通知信息!');
        // window.location.href = data.playGameLink
    }

    // 网文外链
    function wangwenHandle() {
        window.open(data.icp, "_blank");
    }

    // ICP外联
    // function ICPHandle() {
    //     window.location.href = data.icp
    // }
    function backIndex(params) {
        navigate('/index')
    }
    let ICP = "鲁ICP备14029732号-5"
    let beian = "鲁公网安备37021202001700号"
    let beianLink = "https://beian.mps.gov.cn/#/query/webSearch?code=37021202001700"
    if (window.location.hostname.indexOf(".cn") != -1) {
        ICP = "鲁ICP备14029732号-6"
        beian = "鲁公网安备37021202001701号"
        beianLink = "https://beian.mps.gov.cn/#/query/webSearch?code=37021202001701"
    }

    const NowYear = new Date().getFullYear()


    return (
        <div className='max'>
            {/* 头部 */}
            <header className='head'>
                <div className='left'>
                    <div onClick={backIndex} style={{ width: "68px", height: "68px", backgroundColor: "rgb(255, 255, 255)", borderRadius: "6px", marginRight: "10px" }}>
                        <img draggable={false} alt='' className='headLogo' src={require('../img/logo.png')}></img>
                    </div>
                    <div style={{ width: "140px", height: "60px", textAlign: "center" }}>
                        <img onClick={backIndex} draggable={false} alt='' src={require('../img/dingzi.png')}></img>
                        <span style={{ fontSize: "16px", color: "rgba(255, 255, 255,0.6)", letterSpacing: "1px" }}>青岛游戏中心</span>
                    </div>
                </div>
                <div className='right'>
                    {showDownLoad && <img draggable={false} onClick={downLoadHandle} className='downLoadGame cursor' alt='' src={require('../img/download.png')}></img>}
                    <img draggable={false} onClick={playGameHandle} className='cursor' alt='' src={require('../img/begin.png')}></img>
                </div>
            </header>
            <Outlet />
            {/* 底部 */}
            <footer className='footer'>
                {/* <div className='footerKefu'>
                    微信客服：{data.kefuNum}
                    <img onClick={textCopy} style={{ "marginLeft": "10px" }} alt='' src={require('../img/footer/copy.png')}></img>
                </div> */}
                <div>
                    <a href='/about/parentTutelage'>家长监护工程</a>|
                    <a href='/about/about'>关于我们</a>|
                    <a href='/about/userAgreement'>用户协议</a>|
                    <a href='/about/privacyAgreement'>隐私协议</a>|
                    <a href='/about/thirdParty'>第三方信息共享清单</a>
                </div>
                <div style={{ margin: "30px 0" }}>
                    <div className='footerWangwen margin'>青岛大卫骆驼网络科技有限公司版权所有 ©2024-{NowYear}</div>
                    <div className='footerWangwen'>
                        {/* 复制提示 */}
                        {/* <img style={{ "width": "40px", "height": "40px" }} alt='' src={require('../img/footer/brand1.png')}></img> */}
                        {/* {isOpen && <Toast message={message} />} */}

                        <div className='margin' style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", "color": "#606060", marginRight: "10px" }}>
                                <img style={{ "width": "18px", "height": "20px", "marginRight": "4px" }} draggable={false} alt='' src={require('../img/beian.png')}></img>
                                <Link to={beianLink} rel='noreferrer' target='_blank'>{beian}</Link >
                            </div>
                            <span onClick={wangwenHandle} className='mouse'>{ICP}</span>
                        </div>

                    </div>


                    {/* <div className='footerWangwen mouse' onClick={ICPHandle}>鲁ICP备14029732号-3</div> */}
                </div>

                <div className='footerZhonggao'>
                    <p>健康游戏忠告:抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当<br />适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活</p>
                </div>

            </footer>
        </div>
    );
}

export default First;
